/* RANGGRATI home page interactions (rgg-*) */
(function () {
  if (window.__rggInit) return; window.__rggInit = true;
  document.documentElement.classList.add('rgg-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScroller(root) {
    if (root.__rgg) return; root.__rgg = true;
    var track = root.querySelector('.rgg-track');
    if (!track) return;
    var prev = root.querySelector('[data-rgg-prev]');
    var next = root.querySelector('[data-rgg-next]');
    var bar = root.querySelector('.rgg-progress span');
    function step() { var c = track.firstElementChild; return c ? (c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16)) * Math.max(1, Math.floor(track.clientWidth / (c.getBoundingClientRect().width || 1))) : track.clientWidth; }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar) {
        var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = Math.min(100, ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, 0.01)) - 1) * 100 : 0) + '%)';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initTabs(root) {
    if (root.__rggTabs) return; root.__rggTabs = true;
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) window.dispatchEvent(new Event('resize'));
      });
      tab.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs), i = list.indexOf(tab);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = list[(i + (e.key === 'ArrowRight' ? 1 : -1) + list.length) % list.length];
          n.focus(); n.click();
        }
      });
    });
  }

  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (!v.__src) {
          v.querySelectorAll('source[data-src]').forEach(function (s) {
            s.addEventListener('error', function () {
              if (s.dataset.fallback && s.src.indexOf(s.dataset.fallback) === -1) { s.src = s.dataset.fallback; v.load(); if (!reduce && !v.__paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } }
            });
            s.src = (window.innerWidth < 750 && s.dataset.srcSm) ? s.dataset.srcSm : s.dataset.src;
          });
          v.load(); v.__src = true;
        }
        if (!reduce && !v.__paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else { v.pause(); }
    });
  }, { rootMargin: '120px 0px', threshold: 0.25 }) : null;

  function initReels(root) {
    root.querySelectorAll('video[data-rgg-video]').forEach(function (v) {
      if (v.__rggv) return; v.__rggv = true;
      if (vio) vio.observe(v);
      var btn = v.parentNode.querySelector('.rgg-reel__play');
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (v.paused) { v.__paused = false; v.play(); btn.setAttribute('aria-label', 'Pause video'); btn.classList.remove('is-paused'); }
        else { v.__paused = true; v.pause(); btn.setAttribute('aria-label', 'Play video'); btn.classList.add('is-paused'); }
      });
    });
  }

  var rio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.rgg-scroller').forEach(initScroller);
    scope.querySelectorAll('[data-rgg-tabs]').forEach(initTabs);
    initReels(scope);
    scope.querySelectorAll('.rgg-reveal').forEach(function (el) { if (rio && !el.classList.contains('is-in')) rio.observe(el); else el.classList.add('is-in'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();